import React, { useState, useEffect } from "react";
import { Switch, Route, Link, useLocation } from "react-router-dom";

import leftmenuicon from "./../img/left-menu-icon-mobile.png";
import Card from "./../components/Card";
import InfoCard from "./../components/InfoCard";
import Kvk from "./../components/Kvk";
import OperatingReport from "./../components/OperatingReport";
import History from "./../components/History";
import "./../styles/Corporate.scss";
import Slider from "react-slick";
import NavArrow from "../components/NavArrow";
import Api from "../common/api";

const Corporate = () => {
  const [tabs, setTabs] = useState([]);

  let settings = {
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: true,
    nextArrow: <NavArrow direction="right" />,
    prevArrow: <NavArrow direction="left" />,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 4,
          infinite: false,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const lang = localStorage.getItem("lang");
  let size = 2;
  if(lang == "en"){
    size = 3;
  }

  const [Paths, setPaths] = useState(useLocation().pathname.split("/"));
  const [activePath, setActivePath] = useState(
    useLocation().pathname.split("/")[size]
  );
  const [currentTab, setCurrentTab] = useState([]);
  const [banner, setBanner] = useState([]);
  const [isMobileActive, setIsMobileActive] = useState(true);
  const [mobileSort, setMobileSort] = useState(0);


  
  React.useEffect(() => {
    Api.get("/home/getmenu?slug=" + Paths[size-1]).then((res) => {
      setTabs(res.data.items);
      setBanner(res.data.banner);

      if(lang == "en"){
        setCurrentTab(
          res.data.items[res.data.items.findIndex((x) => x.Link_EN == activePath)]
        );
       }else{
        setCurrentTab(
          res.data.items[res.data.items.findIndex((x) => x.Link == activePath)]
        );
       }

      
    });
  }, [activePath]);

  const renderTitle = () => {
    if (currentTab) {
      if(lang =="en"){
        return <h3>{currentTab.Name_EN}</h3>;
      }{
      return <h3>{currentTab.Name}</h3>;

      }
    }
  };

  const adClick = (id,key) => {
    window.scrollTo({ behavior: "smooth", top: 0 });
    const tab = tabs.find((tab) => tab.id === id);

    console.log("Selected tab id : " + id);
    console.log("Selected tab : " + JSON.stringify(tab));

    setCurrentTab(tab);
    setIsMobileActive(true);
    setMobileSort(key)
  };

  function RenderData(tab) {
    if (tab.content.id) {
      if (tab.content.Name === "Yönetim Kurulu") {
        return (
          <>
            {renderTitle(tab.Name)}
            <div className="corporate-modal">
              <Card page="0" />
            </div>
          </>
        );
      }
      if (tab.content.Name === "Yönetim Ekibi") {
        return (
          <>
            {renderTitle(tab.Name)}
            <div className="corporate-modal">
              <Card page="1" />
            </div>
          </>
        );
      }
      if (tab.content.Link === "strateji-ve-is-gelistirme-ekibi") {
        return (
          <>
            {renderTitle(tab.Name)}
            <div className="corporate-modal">
              <Card page="2" />
            </div>
          </>
        );
      }
      if (tab.content.Name === "Bilgi Toplumu Hizmetleri") {
        return (
          <>
            {renderTitle(tab.Name)}
            <div className="corporate-modal">
              <InfoCard />
            </div>
          </>
        );
      }
      if (tab.content.Name === "Kişisel Verilerin Korunması") {
        return (
          <>
            {renderTitle(tab.Name)}
            <div className="corporate-modal">
              <Kvk />
            </div>
          </>
        );
      }
      if (tab.content.id === 1050) {
        return (
          <div className="career-container container-sm">
            <OperatingReport />
          </div>
        );
      }
      if (tab.content.Name === "Tarihçe") {
        return (
          <>
            {renderTitle(tab.Name)}
            <div className="corporate-content-section">
              <History />
            </div>
          </>
        );
      }
      return (
        lang == "en" ? (
        <div className="corporate-content-section">
          <p>
            <br />
            {renderTitle(tab.Name_EN)}
            {tab.content.content.Content_EN ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: tab.content.content.Content_EN,
                }}
              ></div>
              
            ) : null}
          </p>
        </div>
        ):(
          <div className="corporate-content-section">
          <p>
            <br />
            {renderTitle(tab.Name)}
            {tab.content.content.Content_TR ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: tab.content.content.Content_TR,
                }}
              ></div>
              
            ) : null}
          </p>
        </div>

        )
      );
    } else {
      return "";
    }
  }

  return (
    <>
      <header
        className="corporate-header"
        style={{
          backgroundImage:
            `url("https://sankoenerji.com.tr` + banner + `")`,
        }}
      ></header>
      <div className="slider-deneme with-padding container-sm">
        <Slider className="slider-tab" {...settings}>
          {tabs
            ? tabs.map((tab) => {
              return (
                lang == "en" ? (
                  tab.Name_EN ? (
                <Link
                  className={currentTab.id === tab.id ? "tab active" : "tab"}
                  key={tab.id}
                  to={"/en/" + Paths[size-1] + "/" + tab.Link_EN}
                  onClick={() => adClick(tab.id)}
                >
                  {tab.Name_EN}
                </Link>
                ):""
                ) :(  
                  tab.Name ? (
                   <Link
                  className={currentTab.id === tab.id ? "tab active" : "tab"}
                  key={tab.id}
                  to={"/" + Paths[size-1] + "/" + tab.Link}
                  onClick={() => adClick(tab.id)}
                >
                  {tab.Name}
                </Link>
                  ):""
                )
              );
            })
            : null}
        </Slider>
      </div>
      <button
        onClick={() => setIsMobileActive(!isMobileActive)}
        className={!isMobileActive ? "mobile-toggle" : "mobile-toggle deactive"}
      >
        <img src={leftmenuicon} alt="sada" />
      </button>
      <div
        className={
          isMobileActive ? "mobile-santral-tabs active" : "mobile-santral-tabs"
        }
      >
        {tabs
          ? tabs.map((tab,key) => {
            return (
              lang == "en" ? 
              (
                tab.Name_EN ? (
              <li
                className={currentTab.id === tab.id ? "active-tab" : null}
                onClick={() => adClick(tab.id,key)}
                key={key}
                style={{order:key+1}}
              >
                <span>{tab.Name_EN}</span>
              </li>
              ):""
              ):
              (
                tab.Name ? (
                <li
                className={currentTab.id === tab.id ? "active-tab" : null}
                onClick={() => adClick(tab.id,key)}
                key={key}
                style={{order:key+1}}
              >
                <span>{tab.Name}</span>
              </li>
              ):""
              )
            );
          })
          : null}
           <div className="corporate-content-container container-sm only-mobile" style={{order:mobileSort+1}}>
            <div className="corporate-container">
              <Route>
                <RenderData content={currentTab} />
              </Route>
            </div>
          </div>
        </div>

      <div className="breadcrumbz container-sm">
        <ol>
          <li>
            {lang == "en" ? 
              (
                <Link to="/">
                  HomePage <span>&gt;</span>
                </Link>
              )  
              :
              (
                <Link to="/">
                  Anasayfa <span>&gt;</span>
                </Link>
              )}       
          </li>
          <li>
            {lang == "en" ?
            (
              <a href={"/" + Paths[1] + "/corporate"}>
                Corporate <span>&gt;</span>
              </a>
            ):
            (
              <a href={"/" + Paths[1] + "/hakkimizda"}>
                Kurumsal <span>&gt;</span>
              </a>
            )}          
          </li>
          <li>
            {tabs.length > 0 || currentTab.id ? (
              <Link to={Paths[1]}>{renderTitle()}</Link>
            ) : null}
          </li>
        </ol>
      </div>
      <div className="corporate-content-container container-sm only-web">
        <div className="corporate-container">
          <Route>
            <RenderData content={currentTab} />
          </Route>
        </div>
      </div>
    </>
  );
};

export default Corporate;
